import styled from 'styled-components';
import { Linha } from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';

export const ContainerGraficos = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding-top: ${espacamento.pequeno}px;
  padding-bottom: ${espacamento.medio}px;
`;

export const ContainerLegendas = styled.div`
  padding-left: 20px;
`;

export const BordaTabela = styled.div`
  border-bottom: 1px solid #dededd;
  margin-bottom: 10px;
`;

export const LinhaTabela = styled(Linha)`
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  margin-bottom: 0;
  margin-top: 0;
  justify-content: space-between;
  padding: ${espacamento.pequeno}px;
`;

export const CelulaTitulo = styled.span`
  margin: 0;
  width: 80%;
  font-size: 16px;
`;

export const CelulaValor = styled.span`
  margin: 0;
  width: 20%;
  text-align: right;
  font-size: 16px;
`;

export const IconeSecretaria = styled.div`
  padding: ${espacamento.extraPequeno}px;
  border-radius: 100%;
  margin-right: ${espacamento.extraPequeno}px;
`;
